import { Component, type ReactNode } from 'react';
import { Button, Result } from 'antd';

export default class AdminPageBoundary extends Component<
  { children: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    if (this.state.failed)
      return (
        <Result
          status="error"
          title="页面暂时无法显示"
          subTitle="请重新加载页面，或从侧边栏打开其他工作台。"
          extra={
            <Button type="primary" onClick={() => window.location.reload()}>
              重新加载页面
            </Button>
          }
        />
      );
    return this.props.children;
  }
}
